import { useState } from "react";
import { Image, Row, Col, Space, Typography, Drawer, Button } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import logo from "../../assets/images/Logo_(Metro_Medellín).png";

const { Title, Text } = Typography;

export default function PageHeader({
  children,
  title = "titulo",
  head = "",
  actions,
  help = false,
  mensaje = "ejemplo de demo",
}) {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => setVisible(true);
  const closeDrawer = () => setVisible(false);

  return (
    <div
      style={{
        padding: "10px 10px",
        marginBottom: 20,
      }}
    >
      <Row justify="space-between" align="middle" wrap>
        <Col>
          <Space align="center">
            {logo && (
              <Image
                src={logo}
                alt="Logo"
                width={50}
                height={50}
                preview={false}
              />
            )}
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Title level={3} style={{ margin: 0 }}>
                  {title}
                </Title>
                {help && (
                  <>
                    <Button
                      icon={<QuestionCircleOutlined />}
                      onClick={showDrawer}
                      type="text"
                      shape="circle"
                    />
                    <Drawer
                      title={
                        <Space align="center">
                          <Image
                            src={logo}
                            alt="Logo"
                            width={40}
                            height={40}
                            preview={false}
                          />
                          <Title level={4} style={{ margin: 0 }}>
                            Ayuda
                          </Title>
                        </Space>
                      }
                      placement="right"
                      onClose={closeDrawer}
                      open={visible}
                    >
                      <b>
                        <h2 level={5} style={{ marginBottom: 5 }}>
                          {title}
                        </h2>
                      </b>
                      <Space></Space>
                      <Text style={{ textAlign: "justify" }}>{mensaje}</Text>
                    </Drawer>
                  </>
                )}
              </div>
              {head && <Text type="secondary">{head}</Text>}
            </div>
          </Space>
        </Col>

        {actions && (
          <Col>
            <Space>{actions}</Space>
          </Col>
        )}
      </Row>
    </div>
  );
}
